<div class="gpd-config-section">
  <div class="gpd-config-section-header">
    <div>
      <div class="gpd-config-section-title">
        <span i18n="@@projectOverviewTasks">Tasks in the Project Overview</span>
      </div>
      <div class="gpd-config-section-description" i18n="@@projectOverviewTasksConfigDescription">
        Filter and select which tasks are shown in the project status.
      </div>
    </div>
  </div>

  <div class="gpd-config-section-content">
    <dx-tree-list
      #treeList
      [dataSource]="overviewTasks"
      dataStructure="plain"
      keyExpr="taskId"
      parentIdExpr="parentTaskId"
      filterMode="withAncestors"
      height="100%"
      [showBorders]="true"
      [showRowLines]="true"
      [columnAutoWidth]="false"
      (onContentReady)="onContentReady($event)"
      (onSelectionChanged)="onSelectionChanged($event)"
    >
      <dxo-selection mode="multiple" [recursive]="true"></dxo-selection>
      <dxo-search-panel i18n-placeholder="@@search..." placeholder="Search..." [visible]="true" width="280"></dxo-search-panel>
      <dxo-toolbar>
        <dxi-item name="searchPanel" location="before"></dxi-item>
        <dxi-item location="after">
          <app-gpd-button i18n-text="@@save" text="Save" (onClick)="save()"></app-gpd-button>
        </dxi-item>
      </dxo-toolbar>
      <dxi-column dataField="taskTitle" i18n-caption="@@task" caption="Task"></dxi-column>
    </dx-tree-list>
  </div>
</div>

<dx-toast [(visible)]="toastVisible" i18n-message="@@successfullySaved" message="Successfully saved"></dx-toast>
